import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

import { Message, SpinnerService } from 'shared-components';
import { UsuariosContextService } from '../../context/usuarios-context.service';
import { UsuariosService } from '../../services/usuarios.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html'
})
export class UsuariosComponent implements OnInit {

  private _filters;
  public filtersVisible = false;
  public filtersForm: UntypedFormGroup;
  public dropdownInfo: number;
  public usuarios;
  public idiomas;
  public rolesUsuarios;
  public mensajes = new Array<Message>();
  public showError: boolean;
  public newEditModal = false;
  public confirmModal = false;
  public userRoles: string[];
  public deleteRoleModal = false;
  public refreshCheckbox_habilitado = false;

  public itemsPerPage = 10;
  public currentPage = 0; // La paginación en back empieza por 0, como los arrays.
  public totalItems: number;
  public readonly visiblePages = 3;

  public usuarioId;
  public userName;
  public toCloseSpinner = 0;

  public orderBy: string;
  public columnId: number;

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService,
    private readonly _usuariosService: UsuariosService,
    private readonly _usuariosContext: UsuariosContextService,
    private readonly _translate: TranslateService) { }

  ngOnInit() {
    this.filtersForm = this._fb.group({
      rol: [''],
      nombreUsuario: [''],
      email: [''],
      idioma: [''],
      habilitado: [''],
    });

    this._usuariosContext.usuariosFilters = null;

    this.getIdiomas();
    this.getRolesUsuarios();
    this.getUsuarios();

  }

  public get role() {
    return this._sessionContext.sessionUser.role;
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get isSmallScreen(){
    return this._sessionContext.isSmallScreen();
  }

  public getRolesUsuarios() {
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._usuariosService.getRolesUsuarios().toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then((resp) => {
      this.rolesUsuarios = resp.map(r => ({id: r.applicationRoleId, des: r.roleName}));
    });
  }

  public getIdiomas() {
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._usuariosService.getIdiomas().toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then((resp) => {
      this.idiomas = resp;
    });
  }

  public showDetails(i: number) {
    this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
    // Desplazamiento a la izquierda para tablet (mismo tamaño máximo que en table.scss)
    if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
      // Retardo en caso de que haya otro detalle abierto
      setTimeout(() => {
          document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
      }, 50);
    }
  }

  public pageChange(page) {
    this.dropdownInfo = -1;
    this._usuariosContext.usuariosFilters.numPagina = this.currentPage = page - 1;
    this.getUsuarios();
  }

  public itemsPerPageChange(items) {
    this.dropdownInfo = -1;
    this._usuariosContext.usuariosFilters.numPagina = this.currentPage = 0;
    this._usuariosContext.usuariosFilters.tamPagina = this.itemsPerPage = items;
    this.getUsuarios();
  }

  public checkValuesForm(): boolean {
    return (this.filtersForm.get('rol').value ||
      this.filtersForm.get('nombreUsuario').value ||
      this.filtersForm.get('email').value ||
      this.filtersForm.get('idioma').value ||
      !this.filtersForm.get('habilitado').pristine) ? true : false;
  }

  public resetForm() {
    this.filtersForm.reset();
    this.refreshCheckbox_habilitado = true;
  }

  public pristineCheckbox(idForm:string, pristine:boolean){
    const form = this.filtersForm.get(idForm);
    pristine ? form.markAsPristine() : form.markAsDirty();
  }

  public filtrar() {
    if (this.filtersForm.valid) {
      this.applyFilters();
    }
  }

  private applyFilters() {
    this.currentPage = 0;
    this._usuariosContext.usuariosFilters = {
      roleName: this.filtersForm.get('rol').value ? this.filtersForm.get('rol').value.des : '',
      userName: this.filtersForm.get('nombreUsuario').value ? this.filtersForm.get('nombreUsuario').value : '',
      email: this.filtersForm.get('email').value ? this.filtersForm.get('email').value : '',
      idiomaId: this.filtersForm.get('idioma').value ? this.filtersForm.get('idioma').value.idiomaId : '',
      activo: this.filtersForm.get('habilitado').value ? this.filtersForm.get('habilitado').value : '',
      numPagina: this.currentPage,
      tamPagina: this.itemsPerPage
    };

    this.getUsuarios();
  }

  public getUsuarios() {
    if (this._usuariosContext.usuariosFilters) {
      this._filters = this._usuariosContext.usuariosFilters;
    } else {
      this.applyFilters();
    }
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._usuariosService.getUsuarios(this._filters).toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then((resp) => {
      this.totalItems = resp.paginacionMeta.totalCount;
      this.usuarios = resp.lista;
    }, (error) => {
      this.showError = true;
      this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
    });
  }

  public create() {
    this.usuarioId = null;
    this.newEditModal = true;
  }

  public update(usuario) {
    this.usuarioId = usuario.applicationUserId;
    this.newEditModal = true;
  }

  public openConfirm(usuario) {
    this.userName = usuario.userName;
    this.confirmModal = true;
  }

  public resetPassword() {
    this._usuariosService.autoGeneratePassword([this.userName]).toPromise().finally(() => {
      this._spinnerService.hideSpinner();
    }).then((resp) => {

    });
    this.closeConfirm();
  }

  public close() {
    this.newEditModal = false;
  }

  public closeConfirm() {
    this.confirmModal = false;
  }

  public refreshData(value) {
    this.newEditModal = false;
    if (value) {
      this.getUsuarios();
    }
  }

  public pushMessage(mensaje) {
    this.showError = true;
    this.mensajes.push({ class: 'success', message: mensaje });
  }

  private checkCloseSpinner() {
    this.toCloseSpinner -= 1;
    if (this.toCloseSpinner === 0) {
      this._spinnerService.hideSpinner();
    }
  }

  public openDeleteRole(usuario) {
    this.userName = usuario.userName;
    this.userRoles = usuario.roles;
    this.deleteRoleModal = true;
  }

  public closeDeleteRole() {
    this.deleteRoleModal = false;
  }

  public refreshUserRoles(refresh) {
    if (refresh) {
      this.getUsuarios();
    }
    this.closeDeleteRole();
  }

  public getIcon(prop: string) {
    let iconClass = 'fa fa-sort';
    if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty.indexOf(prop) != -1) {
        iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
    }
    return iconClass;
  }

  public toOrderBy(columnFilter, idColumn) {
    this.columnId = idColumn;
    if (this.usuarios && this.usuarios.length > 0) {
      if (this._usuariosContext.usuariosFilters) {
        this._filters = this._usuariosContext.usuariosFilters;
        if (!this.orderBy || this.orderBy.includes('DESC')) {
          this.orderBy = 'ASC' + idColumn;
          this._filters.orderItems = [
            {
              orderProperty: columnFilter,
              orderByDescending: false
            }
          ];
        } else if (this.orderBy.includes('ASC')) {
          this.orderBy = 'DESC' + idColumn;
          this._filters.orderItems = [
            {
              orderProperty: columnFilter,
              orderByDescending: true
            }
          ];
        }
        this.getUsuarios();
      }
    }
  }

  public trackByUsuarioId(index: number, usuario: { applicationUserId: number }): number {
    return usuario.applicationUserId;
  }

}
